import { render, staticRenderFns } from "./InAppCommissionFormFix.vue?vue&type=template&id=12accacc&scoped=true"
import script from "./InAppCommissionFormFix.vue?vue&type=script&lang=js"
export * from "./InAppCommissionFormFix.vue?vue&type=script&lang=js"
import style0 from "./InAppCommissionFormFix.vue?vue&type=style&index=0&id=12accacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12accacc",
  null
  
)

export default component.exports